var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wallet-empty-state" },
    [
      _vm.shouldShowNoClientSelectedCard
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("FeedbackWrapper", {
                    staticClass: "az-card-consolidator",
                    attrs: {
                      noData: true,
                      "icon-name": "users",
                      "icon-color": "primary"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c("ClientEmptyState", {
                                attrs: {
                                  title: _vm.tituloSemSelecao,
                                  description: _vm.descricaoSemSelecao
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center az-gap mt-4"
                                },
                                [
                                  !_vm.ehVisaoDeGrupo
                                    ? _c(
                                        "BaseButton",
                                        {
                                          attrs: { outline: "", primary: "" },
                                          on: { click: _vm.handleOpenNewClient }
                                        },
                                        [_vm._v(" Cadastrar cliente ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: { primary: "" },
                                      on: {
                                        click: _vm.handleAcaoPrimariaSemSelecao
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.rotuloAcaoSemSelecao) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1281019246
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.shouldShowNoAccessCard
        ? _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass: "wallet-empty-state__card az-card-consolidator"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wallet-empty-state__card-title" },
                      [_vm._v(" Você não tem acesso a esse cliente ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "wallet-empty-state__card-description" },
                      [
                        _vm._v(
                          " Envie uma proposta de serviço para esse cliente e tenha acesso a posição dele após a contratação. "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "wallet-empty-state__card-action mt-5",
                        on: { click: _vm.handleSendEmail }
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { "x-large": "", color: "primary" } },
                          [_vm._v(" mdi-bank ")]
                        ),
                        _c("div", { staticClass: "text-center" }, [
                          _vm._v(
                            " Envie convite para ele acessar e cadastrar "
                          ),
                          _c(
                            "strong",
                            { staticStyle: { color: "var(--primary)" } },
                            [_vm._v(" contas automáticas ")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.shouldShowNoClientsRegisteredCard
        ? _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass: "wallet-empty-state__card az-card-consolidator"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wallet-empty-state__card-title" },
                      [_vm._v(" Você não possui nenhum cliente cadastrado ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "wallet-empty-state__card-description" },
                      [
                        _vm._v(
                          " Cadastre seus clientes e envie link dos seus serviços para ele acessar a plataforma/aplicativo e você acompanhar "
                        ),
                        _c(
                          "strong",
                          { staticStyle: { color: "var(--primary)" } },
                          [_vm._v("100% do share da carteira dele")]
                        ),
                        _vm._v(", independente da instituição. ")
                      ]
                    ),
                    _c("div", { staticClass: "d-flex az-gap" }, [
                      _c(
                        "div",
                        {
                          staticClass: "wallet-empty-state__card-action mt-5",
                          on: { click: _vm.handleCollectClientDefault }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { "x-large": "", color: "primary" } },
                            [_vm._v(" mdi-account-arrow-left ")]
                          ),
                          _c("div", { staticClass: "text-center" }, [
                            _vm._v(" Inserir "),
                            _c(
                              "strong",
                              { staticStyle: { color: "var(--primary)" } },
                              [_vm._v(" cliente default ")]
                            ),
                            _vm._v(" com meus dados ")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "wallet-empty-state__card-action mt-5",
                          on: { click: _vm.handleOpenNewClient }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { "x-large": "", color: "primary" } },
                            [_vm._v(" mdi-account ")]
                          ),
                          _c("div", { staticClass: "text-center" }, [
                            _vm._v(" Cadastre um "),
                            _c("br"),
                            _c(
                              "strong",
                              { staticStyle: { color: "var(--primary)" } },
                              [_vm._v(" cliente individual ")]
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.shouldShowNoAssetsCard
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("FeedbackWrapper", {
                    staticClass: "az-card-consolidator",
                    attrs: {
                      noData: true,
                      "icon-name": "wallet-empty",
                      "icon-color": "primary"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c("ClientEmptyState", {
                                attrs: {
                                  title: _vm.rescueMessage,
                                  description:
                                    "Cadastre os ativos dele para visualizar o consolidador da carteira atual."
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center az-gap mt-4"
                                },
                                [
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: { outline: "", primary: "" },
                                      on: { click: _vm.handleImportAssets }
                                    },
                                    [_vm._v(" Importar ")]
                                  ),
                                  _c(
                                    "BaseButton",
                                    {
                                      attrs: { primary: "" },
                                      on: { click: _vm.handleNewAsset }
                                    },
                                    [_vm._v(" Cadastrar Ativo ")]
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2572640168
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.shouldShowClientNoAssetsCard
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("FeedbackWrapper", {
                    staticClass: "az-card-consolidator",
                    attrs: { loading: false, noData: true },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c("ClientEmptyState", {
                                attrs: {
                                  title:
                                    "Você ainda não possui ativos cadastrados",
                                  description:
                                    "Entre em contato com o seu profissional para cadastrar seus ativos e acompanhar sua carteira de investimentos."
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2234505388
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }